<template>
  <div class="sidebar">
      <template v-for="(link, index) in links">
          <router-link v-if="link" :key="index" class="dropdown" :to="link.href">
              <span class="">{{t(link.name)}}</span>
              <div class="dropdown-content" v-if="link.items">
                  <template v-for="(item, index) in link.items" :key="index">
                      <router-link v-if="!item.target" :to="item.href" class="dropdown" :key="`internal-${index}`">
                          <span class="sub-span">{{ t(item.name) }}</span>
                      </router-link>

                      <a v-else :href="item.href" class="dropdown" target="_blank" rel="noopener noreferrer"
                         :key="`external-${index}`" @click.stop>
                          <span class="sub-span">{{ t(item.name) }}</span>
                      </a>
                  </template>
              </div>
          </router-link>
      </template>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
let links = ref([
    {name: 'main', href: '/'},
    {name: 'about', href: '/about/position', items: [
            {name: 'position', href: '/about/position'},
            {name: 'management', href: '/about/management'},
            {name: 'structure', href: '/about/structure'},
            {name: 'photoGallery', href: '/about/photo'},
            {name: 'videoGallery', href: '/about/video'},
            {name: 'media', href: '/about/media'},
            {name: 'bankReq', href: '/about/bank'},
        ]},
    {name: 'regulatoryFramework', href: '/regulatory_framework/legislation', items: [
            {name: 'legislation', href: '/regulatory_framework/legislation'},
            {name: 'decrees', href: '/regulatory_framework/decrees'},
            {name: 'resolution', href: '/regulatory_framework/resolution'},
            {name: 'governmentDecrees', href: '/regulatory_framework/gov-decrees'},
            {name: 'regulatoryLegalActsOfStateBodies', href: '/regulatory_framework/regulatory-legal-acts'},
            {name: 'orders', href: '/regulatory_framework/orders'},
            {name: 'regulations', href: '/regulatory_framework/regulations'},
        ]},
    {name: 'activity', href: '/activity/corruption', items: [
            {name: 'corruption', href: '/activity/corruption'},
            {name: 'ourActivity5Name', href: '/activity/accounting'},
            {name: 'leaseOfStateProperty', href: '/activity/lease-of-state-property'},
            {name: 'propertyRelations', href: '/activity/property-relations'},
            {name: 'companies', href: '/activity/companies'},
            {name: 'businessEntities', href: '/activity/business-entities'},
            {name: 'court-proceedings', href: '/activity/court-proceedings'},
            {name: 'investors', href: '/activity/investors'},
            {name: 'ourActivity2Name', href: '/activity/purchases'},
        ]},
    {name: 'smi', href: '/media/news', items: [
            {name: 'news', href: '/media/news'},
            {name: 'competitions', href: '/media/competitions'},
            {name: 'vacancies', href: '/media/vacancies'},
            {name: 'government-z', href: 'http://zakupki.gov.kg/popp/', target: '_blank'},
        ]},
    {name: 'contacts', href: '/contacts/phone-directory', items: [
            {name: 'phone-directory', href: '/contacts/phone-directory'},
            {name: 'public-reception', href: '/contacts/public-reception'},
            {name: 'electronic-appeals', href: '/contacts/electronic-appeals'},
        ]},
]);
</script>
